module.exports = __webpack_public_path__ + "img/animation1c.8b86c799.gif";